/**
 * SCROLL CUSTOM ELEMENT
 * Handled as a custom element due to their being next to no state to manage, and due to how neatly it interacts with Tailwind
 * Detects which direction a scroll has happened, and adds data attributes to support.
 *
 * For set up:
 *   1. Ensure you wrap your elements with <x-in-view>.
 *   2. Pass a 'data-target-id' to specify what component you're keeping track of.
 *   3. Use "gropu-data-visible:" for stateful styling.
 *
 */

class ScrollDirectionElement extends HTMLElement {
  previousScrollTop = 0

  constructor() {
    super()

    this.isScrollUp = () => {
      return this.dataset.ui === 'scroll-up'
    }

    this.isScrollDown = () => {
      return this.dataset.ui === 'scroll-down'
    }

    this.handleDetectScrollDirection = () => {
      // approach from:
      // https://stackoverflow.com/questions/31223341/detecting-scroll-direction
      const currentScrollTop = window.scrollY || document.documentElement.scrollTop

      if (currentScrollTop > this.previousScrollTop && !this.isScrollDown()) this.dataset.ui = 'scroll-down'
      else if (this.previousScrollTop > currentScrollTop && !this.isScrollUp()) this.dataset.ui = 'scroll-up'
      else this.dataset.ui = undefined

      this.previousScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop
    }
  }

  connectedCallback() {
    window.addEventListener('scroll', this.handleDetectScrollDirection.bind(this))
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleDetectScrollDirection.bind(this))
  }
}

customElements.define('x-scroll-direction', ScrollDirectionElement)
